<template>
  <router-view />
</template>

<script>

export default {
  name: 'BlankLayout'
}
</script>
